import Sortable from "sortablejs";

export function selfReportedTag(args) {
  const {
    placeholder = "",
    tagGroupName = "",
    surveyPrompt = "",
    arrTags = [],
    selectedOption = -2,
    showDeleteModal = false,
    deleteConfirmText = "",
    multilingualEnabled = false,
    langCodes = [],
    tagGroupTranslations = {},
    defaultLanguage = "en",
  } = args;

  return {
    init() {
      const self = this;
      const sortableList = document.getElementById("sortable-list");
      const editableContents = document.querySelectorAll(".editable-content");

      // Only initialize sortable if the element exists (it won't exist on translation tabs)
      if (sortableList) {
        const sortableInstance = new Sortable(sortableList, {
          animation: 150,
          handle: ".handle",
          onStart() {
            editableContents.forEach((content) =>
              content.setAttribute("contenteditable", "false"),
            );
          },
          onEnd() {
            editableContents.forEach((content) =>
              content.setAttribute("contenteditable", "true"),
            );

            const order = Array.from(
              self.$refs.sortableList.querySelectorAll(".sortable-item"),
            )
              .map((item) => item.dataset.optionId)
              .map(Number);

            // reverse Sortable's DOM updates
            const itemsToRemove =
              sortableList.querySelectorAll(".sortable-item");
            itemsToRemove.forEach((item) => {
              sortableList.removeChild(item);
            });

            const itemsToAdd = self.reorderArray(itemsToRemove, order);
            itemsToAdd.forEach((item) => {
              sortableList.appendChild(item);
            });

            // perform DOM updates via Alpine reactivity
            self.arrTags = order.map((index) => self.arrTags[index]);
          },
        });

        editableContents.forEach((content) => {
          content.addEventListener("focus", () => {
            sortableInstance.option("disabled", true);
          });

          content.addEventListener("blur", () => {
            sortableInstance.option("disabled", false);
          });
        });
      }
    },

    tagGroupName,
    surveyPrompt,
    placeholder,
    arrTags,
    selectedOption,
    showDeleteModal,
    deleteConfirmText,
    multilingualEnabled,
    langCodes,
    tagGroupTranslations,
    activeLanguage: defaultLanguage,
    defaultLanguage,
    removeEntry(event) {
      const itemPosition =
        event.target.closest(".sortable-item").dataset.optionId;
      this.arrTags = this.arrTags.filter(
        (_row, index) => index !== parseInt(itemPosition),
      );
    },
    addEntry() {
      const newTag = {
        name: "",
        translations: {},
      };
      // Initialize translations structure for each language
      this.langCodes.forEach((lang) => {
        newTag.translations[lang] = { name: "" };
      });
      this.arrTags.push(newTag);

      this.$nextTick(() => {
        this.$refs["newOption"].focus();
      });
    },
    isDuplicate(name) {
      return this.arrTags.filter((tag) => tag.name === name).length > 1;
    },
    hasDuplicate() {
      return this.arrTags.some((tag) => this.isDuplicate(tag.name));
    },
    updateName(event, option) {
      const updatedName = event.target.textContent;
      option.name = updatedName;
    },
    canAddOption() {
      // max number of options is 11
      return this.arrTags.length < 11;
    },
    reorderArray(array, order) {
      const newArray = new Array(array.length);
      order.forEach((newIndex, originalIndex) => {
        newArray[newIndex] = array[originalIndex];
      });

      return newArray;
    },
    formValid() {
      return (
        this.tagGroupName &&
        this.surveyPrompt &&
        this.arrTags.filter((tag) => tag.name.trim() !== "").length >= 2 &&
        !this.hasDuplicate()
      );
    },
    hasTranslation(lang) {
      // Check if tag group prompt has translation
      const tagGroupTranslation = this.tagGroupTranslations[lang];
      if (!tagGroupTranslation || !tagGroupTranslation.prompt) return false;

      // Check if all tags have translations
      const validTags = this.arrTags.filter((tag) => tag.name.trim() !== "");
      return validTags.every((tag) => {
        const tagTranslation = tag.translations && tag.translations[lang];
        return tagTranslation && tagTranslation.name;
      });
    },
    get allTranslated() {
      if (!this.multilingualEnabled) return true;
      if (this.langCodes.length === 0) return true;

      return this.langCodes.every((lang) => this.hasTranslation(lang));
    },
  };
}
